/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2021 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers.  The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */
import { editLink } from "@monsma/App/WidgetExtensions/Addresses/SharedAddressesComponentsStylesExtension";
import { addressWrapper } from "@monsma/App/WidgetExtensions/Addresses/SharedAddressesComponentsStylesExtension";
import { addressBookStyles } from "@monsma/Overrides/Widgets/Addresses/AddressBook";
import { screen } from "@monsma/XDL/Helpers";
import { css } from "styled-components";

addressBookStyles.xngStyles = {
    wrapper: addressWrapper,
    addressActions1: {
        belowMdHidden: {
            css: css`
                &&& {
                    display: block;
                }
            `,
        },
        aboveSmHidden: {
            css: css`
                &&& {
                    display: none;
                }
            `,
        },
        actionUseAsShippingAddressButton: {
            css: css`
                display: none;
            `,
        },
        actionEditLink: editLink,
    },
    addressActions2: {
        actionEditLink: {
            css: css`
                display: none;
            `,
        },
        overflowMenu: {
            cssOverrides: {
                menu: css`
                    li {
                        padding: 5px 0 0;

                        &:last-child {
                            display: none;
                        }
                      
                        &:first-child {
                          display: list-item;
                        }
                    }
                `,
            },
        },
    },
};

addressBookStyles.titleText = {
    ...addressBookStyles.titleText,
    css: css`
        margin-bottom: 0;
    `,
};

addressBookStyles.addressCard = {
    addressInfoDisplayGridItem: {
        ...addressBookStyles.addressCard?.addressInfoDisplayGridItem,
        css: css`
            flex-direction: column;
        `,
    },
    actionsGridItem: {
        ...addressBookStyles.addressCard?.actionsGridItem,
    },
};

addressBookStyles.addressHeaderGridItem = {
    ...addressBookStyles.addressHeaderGridItem,
    css: css`
        > div > div > div > div > div {
            ${screen("lte", "xs")} {
                &:first-child {
                    max-width: unset;
                    flex-basis: unset;
                    flex: 1;
                }

                &:last-child {
                    flex: 0 0 auto;
                }
            }
        }

        &.not-allowed-to-create-address {
            > div > div > div > div > div {
                &:last-child {
                    display: none;
                }
            }
        }
    `,
};
